import type { Features } from '~/provides/features.types';

/** Whether the Franchise Hub dashboard is the person's home page, in place of Analytics · Dashboard. */
export const franchiseHubDashboardShown = (features: Features, onCorporate: boolean): boolean =>
    Boolean(features.contact_groups) &&
    Boolean(features.franchise_hub_dashboard) &&
    onCorporate &&
    Boolean(Spark.isAdminOrOwner || Spark.isPlatformAdmin);
